import React from "react";
import {ErrorUtil} from "@/utils/ErrorUtil";

export function ErrorFull(props: { error: any }) {
    return (
        <div style={{marginTop: 24, color: "red", fontSize: 16}}>
            <span style={{fontWeight: 'bold'}}>ERROR:</span>
            &nbsp;
            {ErrorUtil.getErrorMessage(props.error)}
        </div>
    );
}
